import { render, staticRenderFns } from "./welcomeLanguageEdit.vue?vue&type=template&id=26275746&scoped=true"
import script from "./welcomeLanguageEdit.vue?vue&type=script&lang=js"
export * from "./welcomeLanguageEdit.vue?vue&type=script&lang=js"
import style0 from "./welcomeLanguageEdit.vue?vue&type=style&index=0&id=26275746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26275746",
  null
  
)

export default component.exports